
/* injects from baggage-loader */

'use strict';

import ReturnsCalculatorController from './returns-calculator.controller';
import ReturnsCalculatorTemplate from './returns-calculator.html';

export default class ReturnsCalculatorComponent {
		constructor() {
				this.templateUrl = ReturnsCalculatorTemplate;
				this.controller = ReturnsCalculatorController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				// this.bindings = { };
		}
}
